import React from 'react'
import { useDropzone } from 'react-dropzone'
import Loader from '@byma/shared/components/Loader'
import useAuth from '@byma/shared/hooks/useAuth'

export default function Upload({ value, accept, onChange }) {
    const { token } = useAuth()
    const [loading, setLoading] = React.useState(false)

    async function onDrop(acceptedFiles) {
        acceptedFiles.forEach(async (file) => {
            setLoading(true)
            try {
                const signReq = await fetch('/api/uploader/getSignedUrl', {
                    method: 'POST',
                    body: JSON.stringify({
                        fileName: file.name,
                        fileType: file.type
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'Auth': token,
                    }
                } )
                const signedUrl = await signReq.json()

                const upload = await fetch(signedUrl.signedRequest, {
                    method: 'PUT',
                    body: file,
                    headers: {
                        'Content-Type': file.type
                    },
                } )

                if (upload.status !== 200) {
                    const res = await upload.text()
                    console.log(res)
                    throw new Error('Failed to upload')
                }

                onChange(signedUrl.url)
            } catch (e) {
                alert('ErrorUploadingFile')
                console.log(e)
            }
            setLoading(false)
        })
    }

    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept,
    })


    return (
        <div {...getRootProps({className: 'dropzone focus:outline-none outline-none flex space-x-2 md:space-x-4'})}>
            {loading ? <Loader /> : (
                <div className="border-dashed border-2 dark:border-gray-400  p-6 text-center text-gray-700 dark:text-gray-200 w-full items-center justify-center flex">
                    <input {...getInputProps()} className="outline-none focus:outline-none" />
                    <p>Clique ou arraste aqui um arquivo para enviar</p>
                </div>
            )}
        </div>
    )
}
